module.exports = __webpack_public_path__ + "assets/img/384f97388323469a616d944886dece7f.svg";